import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import TabbedContainer from "../App/components/common/TabbedContainer";
import MarketMarks from "./submitMarks/marketMarks";
import MarketTrades from "./submitTrades/marketTrades";
import ExternalData from "./submitExternalData/externalData";
import { usePermitted } from "../common/components/permissions/permissions";
import { useKeycloak } from "@react-keycloak/web";

const SubmitData = ({ market, venues, termSchedules, externalData, t }) => {
  const [activeTab, setActiveTab] = useState("submitMarks");

  // Find the term schedule for the selected market
  const termSchedule =
    termSchedules &&
    termSchedules.find((x) => x.termScheduleId === market.termScheduleId);

  // Find the venue for the selected market
  const venue = venues && venues.find((x) => x.venueId === market?.venueId);

  const productId = market?.productId;

  const { keycloak, initialized } = useKeycloak();

  // Marks permissions
  const allowEditMarks = usePermitted(["api-manage-marks"]);
  const allowEditOnBehalfMarks = usePermitted(["api-approve-marks"]);
  const allowOverrideMarks = usePermitted(["api-approve-marks"]);
  const allowGenerateMarks = usePermitted(["api-generate-marks"]);
  const allowCopyMarks = usePermitted(["api-copy-marks"]);

  // Trades permissions
  const allowEditTrades = usePermitted(["api-manage-trades"]);
  const allowEditOnBehalfTrades = usePermitted(["api-approve-trades"]);

  const userAccountId =
    initialized && keycloak.tokenParsed.OriginatingUserAccountID;
  const userOrganizations = initialized && keycloak.tokenParsed.group;

  const tabs = [
    {
      id: "submitMarks",
      label: t("MarketDataSubmitMarks"),
      icon: "fa fa-comment-dollar",
      content: (
        <MarketMarks
          productId={productId}
          market={market}
          userAccountId={userAccountId}
          userOrganizations={userOrganizations}
          allowEdit={allowEditMarks}
          allowEditOnBehalf={allowEditOnBehalfMarks}
          allowOverrideMarks={allowOverrideMarks}
          allowGenerateMarks={allowGenerateMarks}
          allowCopyMarks={allowCopyMarks}
          venue={venue}
          termSchedule={termSchedule}
        />
      ),
    },
    {
      id: "submitTrades",
      label: t("MarketDataSubmitTrades"),
      icon: "fa fa-comments-dollar",
      content: (
        <MarketTrades
          productId={productId}
          market={market}
          userAccountId={userAccountId}
          userOrganizations={userOrganizations}
          allowEdit={allowEditTrades}
          allowEditOnBehalf={allowEditOnBehalfTrades}
        />
      ),
    },
  ];

  // Add external data tab if available
  if (externalData) {
    tabs.push({
      id: "submitExternalData",
      label: t("MarketDataSubmitExternalData"),
      icon: "fa fa-comment-nodes",
      content: (
        <ExternalData
          marketId={market.marketId}
          userAccountId={userAccountId}
          userOrganizations={userOrganizations}
        />
      ),
    });
  }

  return (
    <TabbedContainer
      activeTab={activeTab}
      onTabChange={setActiveTab}
      tabs={tabs}
    />
  );
};

export default withTranslation()(SubmitData);
